var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22 9.00073L12 5.00073L2 9.00073L12 13.0007L22 9.00073ZM22 9.00073V15.0007M6 10.6008V16.0008C6 16.7965 6.63214 17.5595 7.75736 18.1222C8.88258 18.6848 10.4087 19.0008 12 19.0008C13.5913 19.0008 15.1174 18.6848 16.2426 18.1222C17.3679 17.5595 18 16.7965 18 16.0008V10.6008", stroke: "#222429", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});